export class Field {
    constructor(
        description,
        field
    ) {
        this.description = description;

        this.value = field && field.value
            ? (description.format ? description.format(field.value) : field.value)
            : '';
        this.valueToDisplay = field && field.valueToDisplay ? field.valueToDisplay : null;

        this.touched = field && field.touched ? field.touched : false;
        this.valid = field && field.valid ? field.valid : false;
        this.prompt = field && field.prompt ? field.prompt : false;
    }
}